module.exports = __webpack_public_path__ + "static/media/savings_share_image.fc0c0b88.png";